var p = Object.freeze, y = Object.defineProperty;
var a = (o, t) => p(y(o, "raw", { value: p(t || o.slice()) }));
import { i as E, x as f } from "./lit-element-CwWchyls.js";
import { n as u } from "./property-EvzlnPW3.js";
import { r as h } from "./state-D88UmDIj.js";
import { e as O } from "./class-map-CiBNip0q.js";
import { L as S } from "./lds-element-4P-EWHZh.js";
import { s as N, a as C } from "./context-D-64zexR.js";
import { generateUUID as I } from "./utils/uuid.js";
import { L as M } from "./multi-select.component-4oMTct2c.js";
import "./lds-checkbox.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class m {
  constructor(t, e, s, i) {
    var l;
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (c, d) => {
      this.unsubscribe && (this.unsubscribe !== d && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = c, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(c, d)), this.unsubscribe = d;
    }, this.host = t, e.context !== void 0) {
      const c = e;
      this.context = c.context, this.callback = c.callback, this.subscribe = (l = c.subscribe) != null ? l : !1;
    } else this.context = e, this.callback = s, this.subscribe = i != null ? i : !1;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new N(this.context, this.t, this.subscribe));
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function R({ context: o, subscribe: t }) {
  return (e, s) => {
    typeof s == "object" ? s.addInitializer(function() {
      new m(this, { context: o, callback: (i) => {
        e.set.call(this, i);
      }, subscribe: t });
    }) : e.constructor.addInitializer((i) => {
      new m(i, { context: o, callback: (l) => {
        i[s] = l;
      }, subscribe: t });
    });
  };
}
var v;
const L = E(v || (v = a(["\n    .base {\n        cursor: pointer;\n        padding: var(--lds-spacing-sm) var(--lds-spacing-md);\n        background-color: var(--lds-color-default-0);\n        user-select: none;\n    }\n\n    .base:hover {\n        background-color: var(--lds-color-default-20);\n    }\n\n    .base.selected {\n        background-color: var(--lds-color-primary);\n        color: var(--lds-text-invert);\n    }\n\n    .multi-select .base.selected {\n        background-color: transparent;\n    }\n"])));
var T = Object.defineProperty, n = (o, t, e, s) => {
  for (var i = void 0, l = o.length - 1, c; l >= 0; l--)
    (c = o[l]) && (i = c(t, e, i) || i);
  return i && T(t, e, i), i;
}, x, g;
const b = class b extends S {
  constructor() {
    super(), this.role = "option", this.value = "", this.selected = !1, this.uuid = I(), this.isMultiSelectOption = !1, this.addEventListener("click", this.onClick);
  }
  onClick() {
    var t, e;
    (e = (t = this.context) == null ? void 0 : t.setActive) == null || e.call(t, this);
  }
  firstUpdated() {
    this.parentElement instanceof M && (this.isMultiSelectOption = !0);
  }
  // https://github.com/shoelace-style/shoelace/blob/next/src/components/option/option.component.ts#L109
  /** Returns a plain text label based on the option's content. */
  getTextLabel() {
    const t = this.childNodes;
    let e = "";
    return [...t].forEach((s) => {
      s.nodeType === Node.ELEMENT_NODE && (s.hasAttribute("slot") || (e += s.textContent)), s.nodeType === Node.TEXT_NODE && (e += s.textContent);
    }), e.trim();
  }
  render() {
    var t, e, s;
    return f(g || (g = a([' <div\n            part="base"\n            class="base', '">\n            ', "\n            <slot></slot>\n        </div>"])), O({
      selected: !this.isMultiSelectOption && ((t = this.context) == null ? void 0 : t.activeOption) === this.uuid
    }), this.isMultiSelectOption ? f(x || (x = a(["<lds-checkbox\n                      readonly\n                      ?checked=", "></lds-checkbox>"])), !!((s = (e = this.context) == null ? void 0 : e.activeOptions) != null && s.includes(this.uuid))) : "");
  }
};
b.styles = L;
let r = b;
n([
  u({ type: String, reflect: !0 })
], r.prototype, "role");
n([
  u({ type: String, reflect: !0 })
], r.prototype, "value");
n([
  u({ type: Boolean, reflect: !0 })
], r.prototype, "selected");
n([
  R({ context: C, subscribe: !0 }),
  h()
], r.prototype, "context");
n([
  h()
], r.prototype, "uuid");
n([
  h()
], r.prototype, "isMultiSelectOption");
const k = new URL(import.meta.url), $ = k.searchParams.has("debug");
if (!k.searchParams.has("no-define")) {
  const o = customElements.get("lds-option");
  o ? o.VERSION !== r.VERSION && $ && console.log("%clds-option tried loading in version ".concat(r.VERSION, ", but lds-option is already defined as ").concat(o.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-option", r);
}
export {
  r as LdsOption
};
